import { User } from './interfaces';

export function fullName(user: User) {
  return user.anonymous ? `${user.name}#${user.anonymousNumber}` : user.name;
}

export function isAnonymousName(name: string) {
  return /^anonymous$/i.test(name);
}
